<template>
  <div class="" v-if="showCount">
    <p v-if="!isEnd" :style="{ color: isLessThan30 ? 'red' : '#18a918' }">
      <span style="color: #333;">报装倒计时：</span><span>{{ h }}:</span><span>{{ m }}:</span><span>{{ s }}</span>
    </p>
    <template v-else>
      <span style="color: red;">已超时，自动报装</span>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    time: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showCount: false,
      h: 0,
      m: 0,
      s: 0,
      isEnd: false,
      isLessThan30: false,
      showTimer: null
    }
  },
  mounted() {
    // this.checkShowCount()
    // 每秒检查一次是否在9-17点范围内
    this.showTimer = setInterval(() => {
      this.checkShowCount()
    }, 1000)
  },
  beforeDestroy() {
    if (this.showTimer) {
      clearInterval(this.showTimer)
      this.showTimer = null
    }
  },
  watch: {
    time: {
      handler(newVal) {
        if (newVal) {
          this.checkShowCount()
        }
      },
      immediate: true
    }
  },
  methods: {
    checkShowCount() {
      var now = new Date()
      var hour = now.getHours()
      // 只有在9点到17点之间才显示倒计时
      if (hour >= 9 && hour < 17) {
        this.showCount = true
        if (this.time) {
          this.isEnd = false
          this.countTime()
        }
      } else {
        this.showCount = false
      }
    },
    countTime() {
      var date = new Date()
      var hour = date.getHours()
      // 只在9-17点范围内执行倒计时
      if (hour < 9 || hour >= 17) {
        this.showCount = false
        return
      }

      // 获取今天9点的时间戳
      var today9 = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 9, 0, 0)
      var inputTime = new Date(this.time).getTime()
      // 获取当前时间
      var now = date.getTime()

      // 判断time是否在今天9点之前
      var baseTime
      if (inputTime < today9.getTime()) {
        // time在今天9点之前，baseTime设为今天9点
        baseTime = today9.getTime()
      } else {
        // time在今天9点之后，baseTime = time
        baseTime = inputTime
      }

      // 直接用baseTime作为倒计时目标
      var end = baseTime + 2 * 60 * 60 * 1000
      // 时间差
      var leftTime = end - now
      if (leftTime >= 1000) {
        this.h = Math.floor((leftTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        this.m = Math.floor((leftTime % (1000 * 60 * 60)) / (1000 * 60))
        this.s = Math.floor((leftTime % (1000 * 60)) / 1000)
        if (this.h == 0 && this.m < 30) {
          this.isLessThan30 = true
        } else {
          this.isLessThan30 = false
        }
        setTimeout(() => {
          this.countTime()
        }, 1000)
      } else {
        this.isEnd = true
      }
    }
  }
}
</script>

<style scoped></style>
